import api from './index'
import store from '../store/index'
import { axios, pureAxios } from '@/utils/request'
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
// todo1
export function login(parameter) {
  return axios({
    url: (location.host == 'sx.mtwlockan.com' || location.host == 'lock.jsssyxh.com') ?'/auth/lockLogin':'/auth/login',
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo() {
  return axios({
    url: '/system/user/info',
    // url: 'http://localhost:8000/api/stuff/stuff/getuser',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// export function getUser () {
//   return axios({
//     url: 'http://localhost:8000/api/stuff/stuff/getuser',
//     method: 'post',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function logout(token) {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': token
    }
  })
}

export function imgcode() {
  return pureAxios({
    url: '/code',
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter
  })
}


export function forgetPwd(parameter) {
  return axios({
    url: '/auth/weChat/forgetPwd',
    method: 'post',
    data: parameter
  })
}


// 获取安装类型
export function getInstallType(dictType) {
  return axios({
    url: '/system/dict/data/installList',
    method: 'get',
    params: { 'dictType': dictType }
  })
}

// 注册码验证
export function registrationCode(parameter) {
  return axios({
    url: '/auth/registrationCode',
    method: 'post',
    data: parameter
  })
}

// 新员工注册
export function addEmployee(parameter) {
  return axios({
    url: '/auth/addEmployee',
    method: 'post',
    data: parameter
  })
}

// 企业注册
export function addEnterprise(parameter) {
  return axios({
    url: '/auth/addEnterprise',
    method: 'post',
    data: parameter
  })
}

// 发送验证码
export function sendIdCode(parameter) {
  return axios({
    url: '/auth/sendIdCode',
    method: 'post',
    data: parameter
  })
}



// 发送验证码
export function sendIdCode2(parameter) {
  return axios({
    url: '/auth/weChat/sendRegisterCode',
    method: 'post',
    data: parameter
  })
}

// 手机号登陆
export function byPhonenumLogin(parameter) {
  return axios({
    url: '/auth/byPhonenumLogin',
    method: 'post',
    data: parameter
  })
}
